export const formatSaleLotOverflow = (overflowPenName, overflowCount) => {
  let result = "";
  if (overflowCount || overflowPenName) {
    result += "o/f";
  }
  if (overflowPenName) {
    result += ` ${overflowPenName}`;
  }
  if (typeof overflowCount === "number" && overflowCount > 0) {
    result += ` (${overflowCount})`;
  }
  return result;
};
